import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { API_BASE_URL } from '../tokens/api-base-url.token';
import { FeedbackApiLoadingService } from './feedback-api-loading.service';

/**
 * Tracks in-flight Feedback API requests via {@link FeedbackApiLoadingService},
 * so the UI can show a loading indicator while any are pending. Scoped by
 * {@link API_BASE_URL} so it only counts Feedback API calls, and `finalize`
 * ensures the count drops whether the request succeeds, errors, or is cancelled.
 *
 * Register it alongside the auth interceptor:
 * @example
 * provideHttpClient(withInterceptors([feedbackApiAuthInterceptor, feedbackApiLoadingInterceptor]))
 */
export const feedbackApiLoadingInterceptor: HttpInterceptorFn = (request, next) => {
  const baseUrl = inject(API_BASE_URL);

  if (!baseUrl || !request.url.startsWith(baseUrl)) {
    return next(request);
  }

  const loading = inject(FeedbackApiLoadingService);
  loading.start();
  return next(request).pipe(finalize(() => loading.stop()));
};
